import { getErrorss } from '../../../functions/errors/GetErrors'
import { type IVerifyPhoneFormValues, type IVerifyPhoneJSON, type ResponseObject } from '../../../types/userTypes/TAuth'
import { urlAUTH } from '../../../urls'
import { authSlice } from '../../slices/authSlice'
import { dataFetchingFinish, dataFetchingStart } from '../../slices/modalSlice'
import { type AppDispatch, type RootState } from '../../store'
import { type User } from '../../slices/userSlice'

export const resetPasswordSendMobileOTP = (formValues?: IVerifyPhoneFormValues) => async (dispatch: AppDispatch, getState: () => RootState) => {

    const phone = formValues?.phone ?? getState().auth.userNUMBER
    try {
        dispatch(dataFetchingStart())
        const sendObject = {
            phone, changePass: true
        }

        const response = await fetch(`${urlAUTH}/sendMobileOTP`, {
            method: 'POST',
            body: JSON.stringify(sendObject),
            headers: {
                'Content-Type': 'application/json'
            }
        })
        const dataJSON: IVerifyPhoneJSON = await response.json()
     
        if (dataJSON.response?.sent) {
            if (formValues?.phone) {
                dispatch(authSlice.actions.numberSuccess(formValues?.phone))
            } else {
                dispatch(authSlice.actions.numberSuccess(phone))
            }
            dispatch(dataFetchingFinish())
            return { ...dataJSON, textNavigate: `/${(getState().user.currentUser as User).Category.toLowerCase()}/modal/my_profile_password_verify_phone/not/not`, isSuccessful: true, textNotification: '' }
        }
        dispatch(dataFetchingFinish())
        return { ...dataJSON, textNavigate: `/${(getState().user.currentUser as User).Category.toLowerCase()}/settings`, isSuccessful: false, textNotification: getErrorss(dataJSON) }
    } catch (error) {
        console.log(error)
    }
}

export const resetPasswordSendMailOTP = (formValues?: IVerifyPhoneFormValues) => async (dispatch: AppDispatch, getState: () => RootState) => {
    const email = formValues?.email ?? getState().auth.userEMAIL
    try {

        dispatch(dataFetchingStart())
        const sendObject = {
            email, changePass: true 
        }
  
        const response = await fetch(`${urlAUTH}/sendMailOTP`, {
            method: 'POST',
            body: JSON.stringify(sendObject),
            headers: {
                'Content-Type': 'application/json'
            }
        })
        const dataJSON: IVerifyPhoneJSON = await response.json()

        if (dataJSON.response?.sent) {
            if (formValues?.email) {
                dispatch(authSlice.actions.emailSuccess(formValues?.email))
            } else {
                dispatch(authSlice.actions.emailSuccess(email))
            }
            dispatch(dataFetchingFinish())
            return { ...dataJSON, textNavigate: `/${(getState().user.currentUser as User).Category.toLowerCase()}/modal/my_profile_password_verify_email/not/not`, isSuccessful: true, textNotification: '' }
        }
        dispatch(dataFetchingFinish())
        return { ...dataJSON, textNavigate: `/${(getState().user.currentUser as User).Category.toLowerCase()}/settings`, isSuccessful: false, textNotification: getErrorss(dataJSON) }
    } catch (error) {
        console.log(error)
    }
}

export const resetPasswordWithPhone = (formValues: IVerifyPhoneFormValues) => async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
   
        dispatch(dataFetchingStart())
        const number = getState().auth.userNUMBER
        const AES_CODE = getState().auth.aes_code
        const sendObject = {
            password: formValues.password, code: AES_CODE, phone: number
        }

        const response = await fetch(`${urlAUTH}/renewPasswordWithMobile`, {
            method: 'POST',
            body: JSON.stringify(sendObject),
            headers: {
                'Content-Type': 'application/json'
            }
        })

        const dataJSON = await response.json() as ResponseObject
        if (dataJSON.success && dataJSON.response?.approved) {
            dispatch(dataFetchingFinish())
            return { ...dataJSON, textNavigate: `/${(getState().user.currentUser as User).Category.toLowerCase()}/settings`, isSuccessful: true, textNotification: 'Your password has been changed' }
        } else {
            dispatch(dataFetchingFinish())
            return { ...dataJSON, textNavigate: '', isSuccessful: false, textNotification: getErrorss(dataJSON) }
        }
    } catch (error) {
        console.log(error)
    }
}

export const resetPasswordWithEmail = (formValues: IVerifyPhoneFormValues) => async (dispatch: AppDispatch, getState: () => RootState) => {
    try {

        dispatch(dataFetchingStart())
        const email = getState().auth.userEMAIL
        const AES_CODE = getState().auth.aes_code
        const sendObject = {
            password: formValues.password, code: AES_CODE, email
        }
        const response = await fetch(`${urlAUTH}/renewPasswordWithMail`, {
            method: 'POST',
            body: JSON.stringify(sendObject),
            headers: {
                'Content-Type': 'application/json'
            }
        })
        const dataJSON = await response.json() as ResponseObject
        if (dataJSON.success && dataJSON.response?.approved) {
            dispatch(dataFetchingFinish())
            return { ...dataJSON, textNavigate: `/${(getState().user.currentUser as User).Category.toLowerCase()}/settings`, isSuccessful: true, textNotification: 'Your password has been changed' }
        } else {
            dispatch(dataFetchingFinish())
            return { ...dataJSON, textNavigate: '', isSuccessful: false, textNotification: getErrorss(dataJSON) }
        }
    } catch (error) {
        console.log(error)
    }
}

export const resetPasswordCheckMobileOTP = (formValues: IVerifyPhoneFormValues) => async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
        dispatch(dataFetchingStart())
        const number = getState().auth.userNUMBER

        const sendObject = {
            ...formValues, changePass: true, phone: number 
        }

        const response = await fetch(`${urlAUTH}/checkMobileOTP`, {
            method: 'POST',
            body: JSON.stringify(sendObject),
            headers: {
                'Content-Type': 'application/json'
            }
        })

        const dataJSON = await response.json() as ResponseObject
        if (dataJSON.success && dataJSON.response?.approved) {
            dispatch(authSlice.actions.aes_codeSuccess(dataJSON.response?.code))
            dispatch(dataFetchingFinish())
            return { ...dataJSON, textNavigate: `/${(getState().user.currentUser as User).Category.toLowerCase()}/modal/my_profile_reset_password_final_phone/not/not`, isSuccessful: true, textNotification: '' }
        } else {
            dispatch(dataFetchingFinish())
            return { ...dataJSON, textNavigate: -1, isSuccessful: false, textNotification: 'Invalid OTP. Try Again.' }
        }
    } catch (error) {
        console.log(error)
    }
}

export const resetPasswordCheckMailOTP = (formValues?: IVerifyPhoneFormValues) => async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
        dispatch(dataFetchingStart())
        const email = getState().auth.userEMAIL

        const sendObject = {
            ...formValues, changePass: true, email //  renew: true,
        }

        const response = await fetch(`${urlAUTH}/checkMailOTP`, {
            method: 'POST',
            body: JSON.stringify(sendObject),
            headers: {
                'Content-Type': 'application/json'
            }
        })

        const dataJSON = await response.json() as ResponseObject
        if (dataJSON.success && dataJSON.response?.approved) {
            dispatch(authSlice.actions.aes_codeSuccess(dataJSON.response?.code))
            dispatch(dataFetchingFinish())
            return { ...dataJSON, textNavigate: `/${(getState().user.currentUser as User).Category.toLowerCase()}/modal/my_profile_reset_password_final_email/not/not`, isSuccessful: true, textNotification: '' }
        } else {
            dispatch(dataFetchingFinish())
            return { ...dataJSON, textNavigate: -1, isSuccessful: false, textNotification: getErrorss(dataJSON) }
        }
    } catch (error) {
        console.log(error)
    }
}
